module.exports = __webpack_public_path__ + "static/img/file-zip.d654e44a.svg";